import React from 'react';

const ContentSkeleton = () => (
  <div className="px-8 py-8 space-y-4 animate-pulse">
    <div className="h-7 bg-gray-200 rounded w-2/3" />
    <div className="h-4 bg-gray-100 rounded w-full" />
    <div className="h-4 bg-gray-100 rounded w-5/6" />
    <div className="h-4 bg-gray-100 rounded w-4/5" />
    <div className="h-5 bg-gray-200 rounded w-1/2 mt-6" />
    <div className="h-4 bg-gray-100 rounded w-full" />
    <div className="h-4 bg-gray-100 rounded w-3/4" />
    <div className="h-4 bg-gray-100 rounded w-5/6" />
    <div className="h-5 bg-gray-200 rounded w-1/3 mt-6" />
    <div className="h-4 bg-gray-100 rounded w-full" />
    <div className="h-4 bg-gray-100 rounded w-4/6" />
  </div>
);

export default ContentSkeleton;
